import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaPhone, FaEnvelope, FaFacebookF, FaTwitter, FaInstagram, FaBars, FaUser, FaSignOutAlt } from 'react-icons/fa';
import { logout } from '../../store/authSlice';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <header className="main-header">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="contact-info">
              <p><FaPhone /> +91-651-XXXX-XXX</p>
              <p><FaEnvelope /> info@newjeevandeep.com</p>
            </div>
            <div className="header-links">
              <ul>
                <li><a href="#"><FaFacebookF /></a></li>
                <li><a href="#"><FaTwitter /></a></li>
                <li><a href="#"><FaInstagram /></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="navbar">
        <div className="container">
          <div className="navbar-wrapper">
            <Link to="/" className="navbar-brand">
              <img src="/images/logo.png" alt="New Jeevan Deep" />
            </Link>

            <button 
              className="navbar-toggler" 
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <FaBars />
            </button>

            <div className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
              <ul className="nav-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/doctors">Doctors</Link></li>
                <li><Link to="/departments">Departments</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                {isAuthenticated && (
                  <li><Link to="/my-appointments">My Appointments</Link></li>
                )}
              </ul>

              <div className="navbar-actions">
                {isAuthenticated ? (
                  <div className="user-menu">
                    <span className="user-name">
                      <FaUser /> {user?.name}
                    </span>
                    <button onClick={handleLogout} className="btn btn-outline">
                      <FaSignOutAlt /> Logout
                    </button>
                  </div>
                ) : (
                  <>
                    <Link to="/login" className="btn btn-outline">Login</Link>
                    <Link to="/book-appointment" className="btn btn-primary">
                      Book Appointment
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
